import { Code, Cloud, Brain, ShieldCheck, PenNib, Users, ArrowRight } from "@phosphor-icons/react";

export const SERVICES = [
  {
    id: "web-mobile",
    icon: Code,
    title: "Web & Mobile Engineering",
    short: "Production-grade apps built with React, Next.js, and React Native.",
    description:
      "From greenfield products to legacy modernization. We ship robust, accessible, performant interfaces backed by clean APIs and pragmatic architecture.",
    deliverables: [
      "Web Apps (React / Next.js)",
      "iOS & Android (React Native)",
      "Design Systems",
      "API Engineering (FastAPI / Node)",
    ],
  },
  {
    id: "cloud-devops",
    icon: Cloud,
    title: "Cloud & DevOps",
    short: "AWS, GCP, and Azure. Containers, Kubernetes, IaC, and CI/CD.",
    description:
      "We architect resilient cloud platforms with cost guardrails, observable infrastructure, and frictionless delivery pipelines.",
    deliverables: ["AWS / GCP / Azure", "Kubernetes & Containers", "Terraform / Pulumi", "CI/CD & GitOps"],
  },
  {
    id: "ai-data",
    icon: Brain,
    title: "AI / ML & Data Analytics",
    short: "LLM apps, RAG systems, MLOps, and modern data platforms.",
    description:
      "From production RAG pipelines to forecasting and analytics dashboards — we build AI products that move business metrics.",
    deliverables: ["LLM & RAG Apps", "MLOps Pipelines", "Data Warehousing", "Analytics Dashboards"],
  },
  {
    id: "cybersecurity",
    icon: ShieldCheck,
    title: "Cybersecurity",
    short: "AppSec, cloud security, audits, and incident response.",
    description:
      "Threat modeling, secure SDLC, penetration testing, and SOC2/ISO27001 readiness — engineered into your stack, not bolted on.",
    deliverables: ["AppSec Audits", "Penetration Testing", "SOC2 / ISO27001", "Secure SDLC"],
  },
  {
    id: "ux-design",
    icon: PenNib,
    title: "UI / UX Design",
    short: "Editorial, structural product design with motion and clarity.",
    description:
      "Strategy-driven product design. We craft interfaces that respect users, communicate brand, and convert.",
    deliverables: ["Product Design", "Design Systems", "Motion & Prototypes", "Brand & Identity"],
  },
  {
    id: "consulting",
    icon: Users,
    title: "IT Consulting & Staffing",
    short: "Fractional CTOs, embedded squads, and senior tech talent.",
    description:
      "Plug a senior team into your roadmap. Strategy, hiring, architecture reviews, and embedded engineering pods.",
    deliverables: ["Fractional CTO", "Embedded Squads", "Architecture Audits", "Talent & Hiring"],
  },
];

export { ArrowRight };
